import { ASSETS } from "../../../../utils/config";

export const getTitle = (title) => {
  if (title?.length > 30) {
    return `${title.substring(0, 30)}.....`;
  }
  return title;
};

export const getFolderIcon = (data) => {
  if (data?.isPrimary) {
    return ASSETS.segmentEditor.PrimaryFolder;
  }
  return data?.visibility === 1
    ? ASSETS.segmentEditor.PublicFolder
    : ASSETS.segmentEditor.PrivateFolder;
};

export const groomWheelSegment = (data) => {
  const wheelSegments = Array.isArray(data?.wheel_segments)
    ? data.wheel_segments
    : [];

  const wheelUpdatedData = [...wheelSegments]?.map((obj) => ({
    ...obj,
  }));

  const wheelUpdatedDataSorted = wheelUpdatedData.sort(
    (a, b) => a.position - b.position
  );
  return wheelUpdatedDataSorted;
};
